define([
    'text!index2021-art/component/page-content.html',
    'index2021-art/common/api',
    'jquery',
    '../common/utils',
    'inView',
    '../../../../vendor/slick/slick.js',
    'css!index2021-art/component/page-content.css',
    'css!vendor/slick/slick.css',
    'css!vendor/slick/slick-theme.css',
    'css!index2020/component/image-slick.css'
], function(
    tpl,
    Api,
    $,
    Utils,
    inView
){
    return {
        template: tpl,
        components: {},
        data: function(){
            return {
                // artTypeList: [
                //     {id: '100',artType: 'EXHIBITION',info: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
                //         infoPhone1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',infoPhone2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。'},
                //     {id: '101',artType: 'STAGE',info: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……',
                //         infoPhone2: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……'},
                //     {id: '102',artType: 'POP-UP',info: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
                //         infoPhone2: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。'},
                // ],
                artTypeList: [
                    {id: '100',artType: '艺术展览',info: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
                        infoPhone1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',infoPhone2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。'},
                    {id: '101',artType: '艺术橱窗',info: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……',
                        infoPhone2: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……'},
                    {id: '102',artType: '艺术快闪',info: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
                        infoPhone2: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。'},
                ],
                onlineIndex: [{num:2,theIndex:0},{num:1,theIndex:2}],//滚动
                shopList: [],
                onlineh: 0,
                shoph: 0,
                isOnline: true,
                isZh: true,
                isPC: true,
                lineNum: 1,

                artExhibtionBottom: [],
                artStageBottom: [],
                artStores: [],
                exhibtionNum: 3,
                exhibtionAllShow: false,
                stageNum: 3,
                stageAllShow: false,

                exhibtTop: 0,
                stageTop: 0,
                storeTop: 0
            };
        },
        methods: {
            getType: function(){
                var _this = this;
                var obj = _this.queryURLParams();
                _this.toScroll(obj.tab);
            },
            queryURLParams: function() {
                var url = window.location.href;
                // 1.创建a标签
                var link = document.createElement('a');
                link.href = url;
                var searchUrl = link.search.substr(1); // 获取问号后面字符串
                var hashUrl = link.hash.substr(1); // 获取#后面的值
                var obj = {}; // 声明参数对象
                // 2.向对象中进行存储
                hashUrl ? obj['HASH'] = hashUrl : null; // #后面是否有值

                var list = searchUrl.split("&");
                for (var i = 0; i < list.length; i++) {
                    var arr = list[i].split("=");
                    obj[arr[0]] = arr[1];
                }
                return obj;
            },
            changeType: function(type){
                var _this = this;
                var urlParams = new URLSearchParams(window.location.search);
                var newUrl = new URL(window.location);
                urlParams.set('tab', type);
                newUrl.search = urlParams.toString();
                history.pushState({}, '', newUrl);
            },
            init: function(){
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                }else {
                    _this.isZh = true;
                }
            },
            getTop: function () {
                var obj = this;
                if(obj.isPC){
                    obj.exhibtTop = $('#exhibtion2021').offset().top-150;
                    obj.stageTop = $('#stage2021').offset().top-150;
                    obj.storeTop = $('#store2021').offset().top-150;
                }else {
                    obj.exhibtTop = $('#exhibtion2021-phone').offset().top-280;
                    obj.stageTop = $('#stage2021-phone').offset().top-280;
                    obj.storeTop = $('#store2021-phone').offset().top-280;
                }
            },
            showMore: function (index) {
                var obj = this;
                if(index===1){
                    obj.exhibtionNum = obj.artExhibtionBottom.length;
                    obj.exhibtionAllShow = true;
                }else{
                    obj.stageNum = obj.artStageBottom.length;
                    obj.stageAllShow = true;
                }
                obj.getTop();
            },
            getScroll: function () {
                var obj = this;
                var scrollTop = $(window).scrollTop();
                obj.getTop();
                if(obj.isPC){
                    if(scrollTop<obj.exhibtTop){
                        $("#exhibtion2021-title").css({position:'relative',top:0,left:0});
                        $("#stage2021-title").css({position:'relative',top:0,left:0});
                        $("#store2021-title").css({position:'relative',top:0,left:0});
                        obj.lineNum = 1;
                    }else if(obj.exhibtTop<=scrollTop&&scrollTop<obj.stageTop-208){
                        $("#exhibtion2021-title").css({position:'fixed',top:'150px',left:'40px'});
                        $("#stage2021-title").css({position:'relative',top:0,left:0});
                        $("#store2021-title").css({position:'relative',top:0,left:0});
                    }else if(obj.stageTop-208<=scrollTop&&scrollTop<obj.stageTop){
                        $("#exhibtion2021-title").css({position:'fixed',top:obj.stageTop-scrollTop-58+'px',left:'40px'});
                        $("#stage2021-title").css({position:'relative',top:0,left:0});
                        $("#store2021-title").css({position:'relative',top:0,left:0});
                    }else if(obj.stageTop<=scrollTop&&scrollTop<obj.storeTop-208){
                        $("#exhibtion2021-title").css({position:'fixed',top:-58+'px',left:'40px'});
                        $("#stage2021-title").css({position:'fixed',top:'150px',left:'40px'});
                        $("#store2021-title").css({position:'relative',top:0,left:0});
                    }else if(obj.storeTop-208<=scrollTop&&scrollTop<obj.storeTop){
                        $("#exhibtion2021-title").css({position:'fixed',top:-58+'px',left:'40px'});
                        $("#stage2021-title").css({position:'fixed',top:obj.storeTop-scrollTop-58+'px',left:'40px'});
                        $("#store2021-title").css({position:'relative',top:0,left:0});
                    }else if(obj.storeTop<=scrollTop){
                        $("#exhibtion2021-title").css({position:'fixed',top:-58+'px',left:'40px'});
                        $("#stage2021-title").css({position:'fixed',top:-58+'px',left:'40px'});
                        $("#store2021-title").css({position:'fixed',top:'150px',left:'40px'});
                    }
                }else {
                    if(scrollTop<obj.exhibtTop){
                        obj.lineNum = 1;
                    }
                }
            },
            toScroll: function(index){
                var obj = this;
                obj.getTop();
                var toThePlace = 0;
                this.lineNum = index;
                if(index===1){
                    toThePlace = 0;
                }else if(index===2){
                    toThePlace = obj.stageTop;
                }else {
                    toThePlace = obj.storeTop;
                }
                Utils.scrollTo(toThePlace);
                obj.changeType(index);
            },
            getInfo: function () {
                var _this = this;
                Api.getHomeDataApi.ajax()
                    .done(function(data){
                        _this.artExhibtionBottom = data.exhibitAll;
                    });
                Api.getPopStoreApi.ajax()
                    .done(function(data){
                        _this.artStores = data;
                    });
                Api.getIndexApi.ajax()
                    .done(function(data){
                        // console.log(data);
                        _this.artStageBottom = data.artist;
                    });
            },
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.getType();
            this.init();
            this.getInfo();
            // this.getTop();
            // this.initAnimate();
            Utils.emitPageReady();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            $(window).scroll(function () {
                obj.getScroll();
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2021-art/component/page-content.js
// module id = 290
// module chunks = 15